import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import React from 'react'

export interface RemoveProductWarningProps {
    onCancel: VoidFunction
    onRemoveProject?: VoidFunction
    isDisplayed: boolean
}

const RemoveProjectWarning: React.FC<RemoveProductWarningProps> = ({
    onCancel,
    onRemoveProject,
    isDisplayed,
}) => {
    const confirmationDialogContent = React.useMemo(() => {
        return (
            <>
                Removing the project will erase all data. This action cannot be
                undone.
            </>
        )
    }, [])

    return (
        <ConfirmationDialog
            dialogHeading={'Remove Confirmation'}
            openDialog={isDisplayed}
            handleDialogClose={onCancel}
            dialogActionCallback={onRemoveProject!}
            contentNode={confirmationDialogContent}
            size="small"
        />
    )
}

export default RemoveProjectWarning
